import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDeptList, saveDepartCharge, deleteDept, getDepartCharge } from "@/api/management/dept";
import treeMenu from "@/components/treeMenu/index.vue";
import deptAdd from "@/components/dialog/deptManage/addList"; //添加

import deptEdit from "@/components/dialog/deptManage/editList"; //编辑

import importExcel from "@/components/dialog/deptManage/importExcel.vue";
import { excelExport } from "@/api/importAndExport/excelApi";
import { mapGetters } from "vuex";
import TreeSelect from "@/components/TreeSelect.vue";
import { getDeptTree, moveDept } from "@/api/managementCenter/otherApi";
export default _defineProperty({
  name: "depManage",
  components: {
    treeMenu: treeMenu,
    deptAdd: deptAdd,
    deptEdit: deptEdit,
    importExcel: importExcel,
    TreeSelect: TreeSelect
  },
  data: function data() {
    return {
      tableLoading: false,
      subDisabled: false,
      delDeptShow: false,
      delDeptName: "",
      delDeptForm: {
        targetDepartmentId: null,
        sourceDepartmentId: null
      },
      delDeptFormRules: {
        targetDepartmentId: [{
          required: true,
          message: "请选择部门",
          trigger: "blur"
        }]
      },
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      departmentData: [],
      filterText: "",
      searchName: {
        username: "",
        name: ""
      },
      deptData: {
        data: [],
        total: 0
      },
      initPage: {
        current: 0,
        size: 10,
        sizes: [10, 20, 50, 100]
      },
      treeSelect: [],
      addData: {
        state: false,
        data: null
      },
      editData: {
        state: false,
        data: null
      },
      personData: {
        userData: null,
        state: false,
        data: null
      },
      uplodData: {
        state: false,
        type: ""
      },
      multipleSelection: [],
      selectedId: "",
      currenTreeId: null
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userData"])), {}, {
    isdisabled: function isdisabled() {
      return this.multipleSelection.length > 0 ? false : true;
    }
  }),
  created: function created() {
    //显示所有部门
    this.refreshDepartment();
  },
  mounted: function mounted() {
    this.treeData = this.$store.getters.chooseDept;
  },
  methods: {
    isAdmin: function isAdmin() {
      return (this.userData.roleCodes || []).includes("ROLE_ADMIN");
    },
    downloadExcel: function downloadExcel() {
      var _this = this;

      this.$DownLoad(excelExport("organ"), null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    cellClass: function cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    handleSelectionChange: function handleSelectionChange(selection, row) {
      // this.multipleSelection = selection;
      this.selectedId = selection.length > 0 ? row.deptId : "";
      this.$refs.deptTable.clearSelection();
      if (selection.length > 0) this.$refs.deptTable.toggleRowSelection(row);
    },

    /**
     * @description: 批量删除
     * @param:{obj}
     * @return:
     */
    deleteOptions: function deleteOptions(row) {
      var _this2 = this;

      if (this.selectedId) {
        this.$confirm("点击“确定”按钮删除选中内容，否则请点击“取消”按钮！", "信息消息", {
          confirmButtonText: "确定",
          cancelButtonText: "关闭",
          type: "warning"
        }).then(function () {
          // const idArr = this.multipleSelection.map(item => {
          //     return item.deptId;
          // });
          deleteDept(selectedId).then(function (res) {
            if (res.data.code == 0) {
              _this2.$message.success("删除成功"); // if (
              //     this.deptData.data.length === idArr.length &&
              //     this.initPage.current > 1
              // ) {
              //     this.deptData.total -= 1;
              //     this.initPage.current -= 1;
              // }


              _this2.refreshDepartment(_this2.initPage.size, _this2.initPage.current, _this2.currenTreeId);
            } else {
              _this2.$message.closeAll();

              _this2.$message.error(res.data.msg);
            }
          }).catch(function (err) {
            _this2.$message.closeAll();

            _this2.$message.error("删除失败");
          });
        });
      } else {
        this.$message.closeAll();
        this.$message.warning("请选择目标项");
      }
    },

    /**
     * @description: 删除
     * @param:{obj}
     * @return:
     */
    remove: function remove(row) {
      var _this3 = this;

      var that = this;
      var data = this.searchTreeData(row.deptId);

      if (data.children.length > 0) {
        this.$alert("还存在着子部门，请先删除子部门！", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      } else {
        this.$confirm("确定删除该部门?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this3.subDisabled = true;
          deleteDept(row.deptId).then(function (res) {
            if (res.data.code == 0) {
              _this3.subDisabled = false; // 重新获取组织部门树

              that.$store.dispatch("getDeptTree").then(function (data) {
                that.$store.commit("SET_CHOOSE_DEPT", data.data.data);
                that.refreshDepartment(_this3.initPage.size, _this3.initPage.current, _this3.treeSelect != null ? _this3.treeSelect.id : null);
              });
            } else {
              _this3.subDisabled = false;

              _this3.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          }).catch(function () {});
        }).catch(function () {});
      }
    },
    transferFn: function transferFn(row) {
      this.delDeptShow = true;
      this.delDeptForm.sourceDepartmentId = row.deptId;
      this.delDeptName = row.name;
      this.getDeptTreeData(row.deptId);
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.delDeptForm.targetDepartmentId = data.id;
    },
    delDeptFn: function delDeptFn(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.moveDeptHttp();
        } else {
          return false;
        }
      });
    },
    moveDeptHttp: function moveDeptHttp() {
      var _this5 = this;

      moveDept(this.delDeptForm).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this5.delDeptShow = false;

          _this5.$message.success(data.msg || "操作成功！");

          _this5.$store.dispatch("getDeptTree").then(function (data) {
            _this5.$store.commit("SET_CHOOSE_DEPT", data.data.data);

            _this5.refreshDepartment(_this5.initPage.size, _this5.initPage.current, _this5.treeSelect != null ? _this5.treeSelect.id : null);
          });
        } else {
          _this5.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this5.$message.error("删除异常！");
      });
    },
    getDeptTreeData: function getDeptTreeData(filterDeptId) {
      var _this6 = this;

      getDeptTree({
        filterDeptId: filterDeptId
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this6.departmentData = data.data;
        }
      }).catch(function (err) {});
    },

    /**
     * @description: 关闭新增
     * @param:{obj}
     * @return:
     */
    closeAdd: function closeAdd(obj) {
      this.addData.state = false;
      this.refreshDepartment(this.initPage.size, this.initPage.current, this.treeSelect != null ? this.treeSelect.id : null);
    },

    /**
     * @description: 新增
     * @param:{}
     * @return:
     */
    openAdd: function openAdd() {
      if (this.treeSelect.length < 1) {
        this.$alert("请先选择左侧一个部门作为上级部门", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      } else {
        this.addData.data = this.treeSelect;
        this.$refs.addModal.showAddData();
        this.addData.state = true;
      }
    },
    // 下载模板
    dowTemplate: function dowTemplate() {
      var _this7 = this;

      this.$DownLoad("/admin/excel/download?type=organ", null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this7.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this7.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    uploading: function uploading() {
      this.uplodData.state = true;
      this.uplodData.type = "organ";
    },
    closeUplod: function closeUplod(val) {
      var _this8 = this;

      this.uplodData.state = val; // this.refreshDepartment(
      //     this.initPage.size,
      //     this.initPage.current,
      //     this.treeSelect != null ? this.treeSelect.id : null
      // );

      this.$store.dispatch("getDeptTree").then(function (data) {
        _this8.$store.commit("SET_CHOOSE_DEPT", data.data.data);
      });
    },

    /**
     * @description: 关闭编辑
     * @param:{obj}
     * @return:
     */
    closeEdit: function closeEdit(obj) {
      this.editData.state = false;
      this.refreshDepartment(this.initPage.size, this.initPage.current, this.treeSelect != null ? this.treeSelect.id : null);
    },

    /**
     * @description: 关闭负责人
     * @param:{obj}
     * @return:
     */
    closePerson: function closePerson(obj) {
      var _this9 = this;

      for (var i = 0; i < obj.data.length; i++) {
        if (isNaN(obj.data[i])) {
          obj.data.splice(i, 1);
        }
      }

      var queryObj = {
        deptId: this.personData.data.deptId,
        charges: obj.data != [] ? obj.data.toString() : null
      };
      saveDepartCharge(queryObj).then(function (res) {
        if (res.data.code == 0) {// this.$message.success("操作成功")
        } else {
          _this9.$alert(res.data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
      this.personData.state = false;
      this.refreshDepartment(this.initPage.size, this.initPage.current, this.treeSelect != null ? this.treeSelect.id : null);
    },

    /**
     * @description: 打开负责人
     * @param:{}
     * @return:
     */
    openPerson: function openPerson(row) {
      var _this10 = this;

      this.personData.data = row;
      getDepartCharge({
        deptId: this.personData.data.deptId
      }).then(function (res) {
        if (res.data.code == 0) {
          var data = res.data.data.split(","); // 在每个逗号(,)处进行分解  ["abc", "abcd", "aaa"]

          for (var i = 0; i < data.length; i++) {
            data[i] = parseInt(data[i]);
          }

          _this10.personData.userData = data;

          _this10.$refs.personModal.loadData();

          _this10.personData.state = true;
        } else {
          _this10.$alert(res.data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
    },

    /**
     * @description: 编辑
     * @param:{}
     * @return:
     */
    openEdit: function openEdit(row) {
      this.editData.data = row;
      this.$refs.editModal.showEditData();
      this.editData.state = true;
    },

    /**
     * @description: 上级部门
     * @param:{pagesize, pageindex, deptId}
     * @return:
     */
    searchParentName: function searchParentName(parentId) {
      var parentName;

      var searchParentName = function searchParentName(searchdata, searchpid) {
        searchdata.forEach(function (e) {
          if (e.id == searchpid) {
            parentName = e.name;
            return;
          } else {
            if (e.children.length > 0) {
              searchParentName(e.children, searchpid);
            }
          }
        });
      };

      searchParentName(this.$store.getters.chooseDept, parentId);
      return parentName;
    },

    /**
     * @description: tree根据id找当前那条数据
     * @param:{id}
     * @return:
     */
    searchTreeData: function searchTreeData(id) {
      var treeData;

      var searchParentName = function searchParentName(searchdata, searchpid) {
        searchdata.forEach(function (e) {
          if (e.id == searchpid) {
            treeData = e;
            return;
          } else {
            if (e.children.length > 0) {
              searchParentName(e.children, searchpid);
            }
          }
        });
      };

      searchParentName(this.$store.getters.chooseDept, id);
      return treeData;
    },

    /**
     * @description: 显示所有部门数据
     * @param:{pagesize, pageindex, deptId}
     * @return:
     */
    refreshDepartment: function refreshDepartment(pagesize, pageindex, deptId) {
      var _this11 = this;

      this.tableLoading = true;
      var queryObj = {
        current: pageindex ? pageindex : this.initPage.current,
        size: pagesize ? pagesize : this.initPage.size,
        pid: deptId ? deptId : "1"
      };
      fetchDeptList(queryObj).then(function (res) {
        _this11.deptData.data = res.data.data.records;
        _this11.deptData.total = res.data.data.total;
        _this11.tableLoading = false;
      });
    },

    /**
     * @description: 分页
     * @param:{num}
     * @return:
     */
    changePage: function changePage(num) {
      this.initPage.current = num;
      this.refreshDepartment(this.initPage.size, this.initPage.current, this.treeSelect != null ? this.treeSelect.id : null);
    },

    /**
     * @description: 选择条数
     * @param:{num}
     * @return:
     */
    handleSizeChange: function handleSizeChange(val) {
      this.initPage.size = val;
      this.initPage.current = 1;
      this.refreshDepartment(this.initPage.size, this.initPage.current, this.treeSelect != null ? this.treeSelect.id : null);
    },

    /**
     * @description: 点击tree
     * @param:{dataId}
     * @return:
     */
    nodeId: function nodeId(data) {
      this.treeSelect = data;
      this.initPage.current = 1;
      this.initPage.size = 10;
      this.currenTreeId = data.id;
      this.refreshDepartment(this.initPage.size, this.initPage.current, data.id);
    }
  }
}, "watch", {
  delDeptShow: function delDeptShow(value) {
    if (!value) {
      this.delDeptForm = {
        targetDepartmentId: null,
        sourceDepartmentId: null
      };
    }
  }
});